import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import postHostStream from 'Api/host-stream/postHostStream';
import postStartStreamRequest from './model/request/postStartStreamRequest';
import postStartStreamResponse from './model/response/postStartStreamResponse';

import { useToast } from 'Store/toast';
import { useUserInfo } from 'Store/userInfo';
import { useHostStreamState } from 'View/host-stream/state';

const usePostStartStream = () => {
  const { t } = useTranslation('host-stream');
  const queryClient = useQueryClient();
  const { updateState } = useHostStreamState();
  const { userId } = useUserInfo();
  const { onOpenToast } = useToast();

  return useMutation({
    mutationFn: async (data) => {
      const payload = await postStartStreamRequest(data);

      const response = await postHostStream(payload);

      const result = postStartStreamResponse(response);

      return result;
    },
    onSuccess: async () => {
      await queryClient.refetchQueries({ queryKey: ['presences', userId] });
      updateState({ selectedView: 'control' });
    },
    onError: async (error) => {
      onOpenToast({
        description: error?.response?.data?.errors[0]?.message || t('error.start_livestream'),
        status: 'failed',
        duration: 5,
        position: 'top',
        type: 'mobile',
      });
    },
    onSettled: async () => {
      updateState({ isLoading: false });
    },
  });
};

export default usePostStartStream;
